/**
 * Class names are affected by these names. If an enum value changes, make sure to search all css files
 * for the old value.
 */
export enum SectionColumnProductInfoType {
  Brand = 'Brand',
  Producer = 'Producer',
  Size = 'Size',
  Quantity = 'Quantity',
  Stock = 'Stock',
  VariantType = 'VariantType',
  VariantPrice = 'VariantPrice',
  VariantSecondaryPrice = 'VariantSecondaryPrice',
  Spacer = 'Spacer',
  TinySpacer = 'TinySpacer',
  Badge = 'Badge',
  ProductTitle = 'ProductTitle',
  Strain = 'Strain',
  StrainType = 'StrainType',
  Label = 'Label',
  Asset = 'Asset',
  QuantityAndSize = 'QuantityAndSize',
  GradingResults = 'GradingResults',
  TagGroups = 'TagGroups',
  Lineage = 'Lineage',
  HelpsWith = 'HelpsWith',
  Effects = 'Effects',
  Aroma = 'Aroma',
  Appearance = 'Appearance',
  GrowingConditions = 'GrowingConditions',
  CraftDesignation = 'CraftDesignation',
  Flavor = 'Flavor',
  TopFlavor = 'TopFlavor',
  EnergyScore = 'EnergyScore'
}
